"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconDeliveryClockOutline = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconDeliveryClockOutline = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, (0, _extends2.default)({
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#nj832phwua)"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M18.328 4a1 1 0 0 1 .97 1.246L19.104 6h1.631a2 2 0 0 1 1.92 1.441l1.154 3.96c.12.167.19.374.19.599v4.5c0 .552-.426 1-.952 1h-1.09l-.003.02a3 3 0 0 1-5.874.175l-.04-.194h-4.123l-.004.02a3 3 0 0 1-5.874.174L6 17.5 4 17.5c-.526 0-1-.448-1-1V14h1v2.5h2l.004-.02a3 3 0 0 1 5.874-.175l.04.195h3.608L18.328 5H9V4h9.328zM8.959 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM19 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm4-3h-5.5v2H19c1.418 0 2.606.983 2.92 2.305l.039.195H23V12zm-2.264-5h-1.884l-1.007 4h4.806l-.955-3.28a1 1 0 0 0-.84-.713L20.736 7z",
  fill: "#666"
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "4.5",
  cy: "8.5",
  r: "4",
  stroke: "#666",
  fill: "none"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#666",
  d: "M4 6h1v3H4z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#666",
  d: "M7 8v1H4V8z"
})), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
  id: "nj832phwua"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
exports.IconDeliveryClockOutline = IconDeliveryClockOutline;
//# sourceMappingURL=IconDeliveryClockOutline.js.map